import { OutlineElement, SlotsController } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';

import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';

import globalStyles from './pc-teaser-card.lightDom.css.lit';
import componentStyles from './pc-teaser-card.css.lit';

/**
 * Insight Teaser Card component
 * @element pc-teaser-card
 * @slot - This element has a default slot
 */
@customElement('pc-teaser-card')
export class PCTeaserCard extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];

  slots = new SlotsController(this);

  adoptedStylesheets: AdoptedStyleSheets;

  @property({ type: String, attribute: 'size' })
  size: 'small' | 'large' | 'prefooter';

  @property({ type: Boolean, attribute: 'has-border-x' })
  hasBorderX = false;

  @property({ type: Boolean, attribute: 'has-border-bottom' })
  hasBorderBottom = false;

  @property({ type: Boolean, attribute: 'dark' })
  dark = false;

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('mouseover', this.handleMouseOver);
    this.addEventListener('mouseout', this.handleMouseOut);
    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
  }

  disconnectedCallback() {
    this.removeEventListener('mouseover', this.handleMouseOver);
    this.removeEventListener('mouseout', this.handleMouseOut);
  }

  render(): TemplateResult {
    const cardClasses = {
      'teaser-card': true,
      [this.size]: !!this.size,
      'has-border-x': this.hasBorderX,
      'has-border-bottom': this.hasBorderBottom,
      'dark': this.dark,
    };

    return html`
      <div class="${classMap(cardClasses)}">
        ${this.slots.conditionalSlot('image', false)}
        <div class="content">
          ${this.slots.conditionalSlot('tag', false)}
          ${this.slots.conditionalSlot('eyebrow', false)}
          ${this.slots.conditionalSlot('title', false)}
          ${this.slots.conditionalSlot('contents', false)}
          ${this.slots.conditionalSlot('cta', false)}
        </div>
      </div>
    `;
  }

  handleMouseOver() {
    this.setAttribute('hovered', 'hovered');
  }

  handleMouseOut() {
    this.removeAttribute('hovered');
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-teaser-card': PCTeaserCard;
  }
}
